export const UPDATE_STATUS = "UPDATE_STATUS";
export const UPDATE_HAS_FEATURE_DOC = "UPDATE_HAS_FEATURE_DOC";
export const CLEAR_DATA = "CLEAR_DATA";
